export default "__VITE_ASSET__Cw78xC_R__"